import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29c9e659"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "get-the-look__product q-row" }
const _hoisted_2 = { class: "q-col-4" }
const _hoisted_3 = { class: "get-the-look__image" }
const _hoisted_4 = { class: "qet-the-look__product-info-box q-col-8" }
const _hoisted_5 = { class: "get-the-look__product-info q-col-12" }
const _hoisted_6 = {
  key: 0,
  class: "get-the-look__brand"
}
const _hoisted_7 = { class: "get-the-look__title" }
const _hoisted_8 = { class: "get-the-look__product-prices-box q-col-12" }
const _hoisted_9 = {
  key: 0,
  class: "get-the-look__discount"
}
const _hoisted_10 = { class: "get-the-look__discount-box" }
const _hoisted_11 = { class: "get-the-look__prices" }
const _hoisted_12 = { class: "get-the-look__price-text" }
const _hoisted_13 = {
  key: 0,
  class: "get-the-look__price-old"
}
const _hoisted_14 = {
  key: 1,
  class: "get-the-look__omnibus"
}
const _hoisted_15 = { class: "get-the-look__omnibus-text" }
const _hoisted_16 = { class: "get-the-look__omnibus-price" }
const _hoisted_17 = ["href", "target"]

import {generateStaticImage, formatPrice, getDiscount, parsePrice} from '@/core/utils'
import {ref, PropType} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GetTheLook',
  props: {
  product: [],
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
},
  setup(__props) {

const props = __props;



const productImage = ref(generateStaticImage(props.product.image_link, 301, null))
const clickLink = ref(props.product.link_click)
const formattedPrice = ref(formatPrice(props.product.price))
const firstVariant = ref(props.product.variants[0])
const brand = ref(firstVariant.value.brand)
const salePrice = ref(formatPrice(firstVariant.value.sale_price))

const actualPrice = salePrice.value ? salePrice.value : formattedPrice.value
const oldPrice = salePrice.value ? formattedPrice.value : salePrice.value

const priceNumber = parsePrice(actualPrice)
const oldPriceNumber = parsePrice(oldPrice)
const discount = ref(getDiscount(priceNumber, oldPriceNumber))

const omnibusPrice = ref(formatPrice(firstVariant.value.omnibus_price))
const omnibusText = ref('Najniższa cena produktu w okresie 30 dni przed wprowadzeniem obniżki: ')
const priceText = ref('Cena regularna: ')

const actualLink = ref(firstVariant.value.link)

const handleClick = () => {
  actualLink.value = clickLink.value
};



return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
        [_directive_lazy, productImage.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (brand.value)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_6, _toDisplayString(brand.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("h2", _hoisted_7, _toDisplayString(__props.product.title), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (discount.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, "-" + _toDisplayString(discount.value) + "%", 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(priceText.value), 1),
          (_unref(oldPrice) && _unref(oldPrice) !== _unref(actualPrice))
            ? (_openBlock(), _createElementBlock("del", _hoisted_13, _toDisplayString(_unref(oldPrice)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("strong", {
            class: _normalizeClass(["get-the-look__price", {'--promotion': discount.value }])
          }, _toDisplayString(_unref(actualPrice)), 3)
        ]),
        (omnibusPrice.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(omnibusText.value), 1),
              _createElementVNode("span", _hoisted_16, _toDisplayString(omnibusPrice.value), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("a", {
      href: actualLink.value,
      onClick: handleClick,
      class: "q-stretched-link get-the-look__link",
      target: __props.useAsSeparate ? '_self' : '_blank'
    }, null, 8, _hoisted_17)
  ]))
}
}

})